import { apiService } from './api.service';

/**
 * Cache partagé des textures de pack (objectURL authentifiés).
 * Évite de re-fetch la même texture à chaque affichage de vignette / changement
 * de page / sélection. Les URLs sont partagées et NON révoquées par les composants
 * (le cache en est propriétaire) — invalidées seulement via clearPackTextureCache.
 */
const urlCache = new Map<string, Promise<string | null>>();

const keyOf = (groupId: string, path: string) => `${groupId}::${path}`;

/** Charge (avec cache + déduplication) l'objectURL d'une texture de pack. */
export function loadPackTextureUrl(groupId: string, path: string): Promise<string | null> {
  const key = keyOf(groupId, path);
  let p = urlCache.get(key);
  if (!p) {
    p = apiService.getPackFileBlobUrl(groupId, path).then((url) => {
      if (!url) urlCache.delete(key); // ne pas mémoriser un échec
      return url;
    });
    urlCache.set(key, p);
  }
  return p;
}

/** Invalide le cache (tout, ou un groupe) et révoque les URLs — après import/sync/édition. */
export function clearPackTextureCache(groupId?: string): void {
  for (const [key, promise] of Array.from(urlCache.entries())) {
    if (groupId && !key.startsWith(`${groupId}::`)) continue;
    promise.then((url) => url && URL.revokeObjectURL(url)).catch(() => {});
    urlCache.delete(key);
  }
}
